import React from "react";

import Cart from "./views/cart/index";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Cart />
    </div>
  );
}

export default App;
